import Vue from 'vue';

export default (cb) => {
  Vue.$http
    .get('Customers/count')
    .then((response) => {
      cb(null, response);
    })
    .catch((error) => {
      console.log(error);
      cb(error);
    });
};



// WEBPACK FOOTER //
// ./src/services/customer/countAll.js